import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { TaskListItemSchema } from '../../entities/task';
/**
 * List My Tasks Request Schema
 * GET /api/v2/task/mine
 * No request body required
 */ export const ListMyTasksRequestSchema = z.void();
/** The caller's open tasks, due date first. */ export const ListMyTasksResponseSchema = z.object({
    tasks: z.array(TaskListItemSchema)
});
export const ListMyTasksErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-my-tasks.schema.js.map